__turbopack_context__.v({
  "item": "product-triggers-module-scss-module__lhPY2G__item",
  "list": "product-triggers-module-scss-module__lhPY2G__list",
});
